import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const SourceRow = styled('tr')`
  .container-error {
    margin-top: 10px;
    font-weight: 500;
  }

  .error {
    display: inline;
    font-size: 18px;
    color: #eb5757;
  }

  .table-cell {
    padding: 24px 10px 16px 0;
    font-size: 16px;
    font-weight: 400;
    color: ${baseTheme.colors.primary};
    border-top: 1px solid ${baseTheme.colors.stroking};
    cursor: pointer;
  }
  .input-comments {
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
  }

  .save-btn {
    margin-top: 20px;
    font-weight: 500;
    font-size: 18px;
    color: ${baseTheme.colors.white};
    padding: 10px 24px;
    background-color: ${baseTheme.colors.mainLightBlue};
    border-radius: 8px;
    width: 143px;
  }

  .disable {
    background-color: ${baseTheme.colors.disabled} !important;
    pointer-events: none;
  }

  .toggle-block {
    display: flex;

    .disableUpdatedAt {
      color: ${baseTheme.colors.secondary};
      padding-left: 8px;
      display: flex;
      align-items: center;
    }
  }

  .toggle-block-active {
    margin-top: 10px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .activeUpdatedAt {
    color: ${baseTheme.colors.secondary};
    padding-left: 8px;
    display: flex;
    align-items: flex-start;
  }

  .activeUpdatedAt {
    display: flex;
    flex-direction: column;
    & .active-info {
      color: ${baseTheme.colors.disabled};
      margin-top: 5px;
    }
  }
  .comment {
    padding: 7px;
    border: solid 1px;
    border-radius: 3px;
  }
  .input-comments-error {
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
    border: solid 1px #eb5757;
  }
  .input-comments {
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
    border: solid 1px #000;
  }
  .comment-error {
    margin: 0;
    color: #eb5757;
  }

  .wrapper {
    position: relative;
    width: 100%;
    height: 40px;
  }

  .container-textarea {
    z-index: 5;
    position: absolute;
    top: 1px;
    left: 1px;
    width: calc(100% - 24px);
    height: 40px;

    & input {
      margin: 0;
      width: 100%;
      padding: 3px !important;
      height: 29px !important;
      min-height: 29px !important;
    }
  }

  .select-group {
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px;
    width: 100%;
  }
`;
